// extracted by mini-css-extract-plugin
export var redoItem = "_mp-1";
export var redoTrigger = "_mp-0";